import React, { useState } from 'react';
import { TaskItem } from '../TaskList';
import { EditPenOutline, TrashIcon } from '../../../../Icons';

interface HiddenTasksProps {
  hiddenTasks: any[];
  upIcon: React.ReactNode;
  downIcon: React.ReactNode;
  onEditTask: (task: any) => void;
  onCompletedTask?: (taskId: any) => Promise<void>;
  onUncompleteTask?: (taskId: any) => Promise<void>;
  onDeleteTask?: (taskId: any) => Promise<void>;
  canAssignTask: boolean;
}
const HiddenTasks = ({
  onEditTask,
  canAssignTask,
  hiddenTasks,
  upIcon,
  downIcon,
  onCompletedTask,
  onUncompleteTask,
  onDeleteTask,
}: HiddenTasksProps) => {
  const [showHiddenTask, setShowHiddenTask] = useState(false);
  return (
    <>
      <div className="completed-tasks-header">
        <button
          type="button"
          onClick={() => setShowHiddenTask((show) => !show)}
        >
          Hidden open tasks
          <span style={{ marginLeft: '4px' }}>
            {showHiddenTask ? downIcon : upIcon}
          </span>
        </button>
      </div>

      {showHiddenTask && (
        <ul>
          {hiddenTasks.map((task) => {
            return (
              <TaskItem
                key={`task-popup-${task.id}`}
                task={task}
                onCompletedTask={onCompletedTask}
                onUncompleteTask={onUncompleteTask}
                editButton={
                  <button type="button" onClick={() => onEditTask(task)}>
                    <EditPenOutline />
                  </button>
                }
                deleteButton={
                  onDeleteTask ? (
                    <button type="button" onClick={() => onDeleteTask(task.id)}>
                      <TrashIcon />
                    </button>
                  ) : undefined
                }
                canAssignTask={canAssignTask}
              />
            );
          })}
        </ul>
      )}
    </>
  );
};

export default HiddenTasks;
